const KG_TO_LBS = 2.20462;
const CM_TO_INCH = 0.393701;

// Weight conversions
export const kgToLbs = (kg) => +(kg * KG_TO_LBS).toFixed(1);
export const lbsToKg = (lbs) => +(lbs / KG_TO_LBS).toFixed(1);

export const displayWeight = (kgValue, unit = 'kg') => {
  if (!kgValue && kgValue !== 0) return '';
  const val = unit === 'lbs' ? kgToLbs(Number(kgValue)) : Number(kgValue);
  return +val.toFixed(1);
};

export const formatWeight = (kgValue, unit = 'kg') => {
  if (!kgValue && kgValue !== 0) return '';
  return `${displayWeight(kgValue, unit)} ${unit}`;
};

export const inputToKg = (value, unit = 'kg') => {
  if (!value && value !== 0) return null;
  return unit === 'lbs' ? lbsToKg(Number(value)) : Number(value);
};

// Height conversions
export const cmToFtIn = (cm) => {
  const totalInches = Math.round(cm * CM_TO_INCH);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return { feet, inches };
};

export const ftInToCm = (feet, inches) => {
  const totalInches = (Number(feet) || 0) * 12 + (Number(inches) || 0);
  return +(totalInches / CM_TO_INCH).toFixed(1);
};

export const displayHeight = (cmValue, system = 'metric') => {
  if (!cmValue && cmValue !== 0) return '';
  if (system === 'imperial') {
    const { feet, inches } = cmToFtIn(Number(cmValue));
    return `${feet}'${inches}"`;
  }
  return `${Number(cmValue).toFixed(1)} cm`;
};

export const formatHeight = (cmValue, system = 'metric') => displayHeight(cmValue, system);

// Measurement system helpers
export const getWeightUnit = (system = 'metric') => system === 'imperial' ? 'lbs' : 'kg';
export const getHeightUnit = (system = 'metric') => system === 'imperial' ? 'ft/in' : 'cm';

// Auto-detect measurement system from browser locale
export const detectMeasurementSystem = () => {
  const lang = navigator.language || navigator.languages?.[0] || 'en';
  const imperialLocales = ['en-US', 'en-LR', 'en-MM'];
  return imperialLocales.some(loc => lang.startsWith(loc)) ? 'imperial' : 'metric';
};
